import axios from 'axios';
import Vue from 'vue';
import VueRouter from 'vue-router';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/lv';
import baguetteBox from 'baguettebox.js';
import smoothscroll from 'smoothscroll-polyfill';
import Big from 'big.js';
import notification_header from './components/EshopNotificationsHeader';
import notification_footer from './components/EshopNotificationsFooter';

smoothscroll.polyfill();

Vue.use(VueRouter);
Vue.use(ElementUI, { locale });

Vue.component('treeselect', require('@riophae/vue-treeselect').default);
Vue.component('group-filter', require('./components/GroupFilter.vue').default);

class Shop {
  constructor(params) {

    window.addEventListener('DOMContentLoaded', () => {
      window.baguetteBox = baguetteBox;
      _.forEach(multiSelectElms, function (e) {
        $('#' + e).selectMultiple({
          afterInit: function () {
            multiSelectObjs[e] = this;
          }
        });
      });
      addMultiSelectCallbacks();
    });
    
    let $this = this;
    this.params = params;
    this.vue = new Vue({
      el: '#eshop_productfilter',
      components : {notification_header, notification_footer},
      router: new VueRouter({
        mode: 'history'
      }),
      data: {
        xScroller_enabled : false,
        xScroller : false,
        xScollerLeft : true,
        xScollerRight : true,
        focused_field : null,
        translations: {},
        currentFilterName: null, // TODO: šo no produkcijas vajadzētu ņemt nost probably.
        secret: params.secret,
        tableType: 0,
        userFilters: params.filters,
        filters: [],
        cartCount: params.cart_count,
        cartItems: {},
        optionsWarehouse: [],
        optionsProducts: [],
        optionsUserFilters: [],
        optionsWaste: [],
        dataWarehouse: [],
        dataProducts: [],
        dataIndustries: [],
        dataApplications: [],
        dataDiscount: false,
        dataRemains: -1,
        dataThicknessFrom: 0,
        dataThicknessTo: 0,
        dataThicknessRange: [0, 0],
        thicknessDisabled: false,
        dataLengthFrom: 0,
        dataLengthTo: 0,
        dataLengthRange: [0, 0],
        lengthDisabled: false,
        dataWidthFrom: 0,
        dataWidthTo: 0,
        dataWidthRange: [0, 0],
        widthDisabled: false,
        dataFiberDirection: false,
        userFilter: null,
        userFilterUncheckLock: false,
        newFilterName: '',
        showNewFilterInput: false,
        tableData: [],
        contacts: {},
        contactdata : {},
        contacts_shown : false,
        totalRows: 0,
        tablePageOptions: [10, 25, 50, 100],
        tablePageSelection: 25,
        tableCurrentPage: 1,
        unitCount: {},
        m2Count: {},
        tableLoading: true,
        cancelUserFilterClick: false,
        lengthFrom: 132,
        lengthTo: 3660,
        lengthRange: [132, 3660],
        widthFrom: 130,
        widthTo: 4000,
        widthRange: [130, 4000],
        showDataTable: true
      },
      computed: {
        tableDefaultSort: function () {
          var order = { prop: 'title', order: 'ascending' };
          if (this.$route.query.by && this.$route.query.or) {
            var o = 'ascending';
            if (this.$route.query.or == 'desc') {
              o = 'descending';
            }
            order = { prop: this.$route.query.by, order: o };
          }
          return order;
        }
      },
      methods: {

        showXScrollButtons(){
          var xScroll = document.querySelector('#shop-app .is-scrolling-left');
          return xScroll !== null ? true : false;
        },

        closeContactCard(e_){
          e_.preventDefault();
          this.contacts_shown = false;
        },

        showContacts(wh_, e_){
          e_.preventDefault();
          this.contactdata = this.contacts[wh_];
          var scrolled = document.documentElement.scrollTop;
          document.getElementById('contact_card_shop').style.top = (e_.clientY + scrolled) - 190 + "px";
          // at the end
          this.contacts_shown = true;
        },

        inputClick(event) {
          // Šis ir vajadzīgs **tikai** priekš IE. Nospiežot uz treeselect elementa
          // un pa tiešo uz input elementa, input elements pretējā gadījumā netiek fokusēts,
          // un vērtību izmaiņas netiek reģistrētas.
          console.debug('tiek manuāli fokusēts input elements:', event.target.id);
          event.target.focus();
        },
        someFiltersChanged: function () {
          this.currentFilterName = null;
        },

        scrollX : function (dir_){
          var scrollel = document.querySelector('.el-table__body-wrapper');
          //document.querySelector('.el-table__body-wrapper').scrollLeft += 100;
          //console.dir(document.querySelector('.el-table__body-wrapper').scrollLeft)
          var options = {
            //top: 0,
            behavior: 'smooth'
          };

          if (dir_=='right')
            options.left = +250;
          else
            options.left = -250;

          scrollel.scrollBy(options);
        },

        addToCart: function () {
          let cart_items = _.pickBy(this.unitCount, _.identity);
          if (_.size(cart_items) == 0) {
            this.$toasted.global.warning($r.shop_msg_emptycartsel);
            return;
          }

          _.each(cart_items, function (count, id) {
            cart_items[id] = parseInt(count);
          });

          axios.post('/' + window.lang + '/shop/addcart', { cart_items })
            .then((response) => {
              let data = response.data;
              switch (data.status) {
                case 1: // Veiksmīga pievienošana
                  this.$confirm(data.msg, {
                    confirmButtonText: $r.shop_cartadd_btngo,
                    cancelButtonText: $r.shop_cartadd_btnstay
                  })
                    .then(() => {
                      window.location = $this.params.cart_url;
                    })
                    .catch(() => {
                      // Refreshojot lapu tiek parādīti pareizi atlikumi,
                      // ņemot vērā lietotāja ielikto grozā.
                      // window.location.reload();
                    });
                  this.cartCount = data.count;
                  break;
                case 2: // Grozā nevar visu ielikt, jo nepietiek atlikumu (netiek ielikts nekas grozā)
                  this.$alert(data.msg);
                  break;
              }

            })
            .catch(err => {
              console.error(err);
            });

        },
        setTableType: function () {

          var q = this.$route.query;

          var wh = q.wh;
          if (typeof wh == 'object') {
            wh = wh[0]; // pietiek ar vienu vērtību, jo nevar vienlaicīgi selektēt vt un mt 
          }
          var whType = _.find(this.filters.wh, function (o) {
            if (wh == o.id || _.find(o.children, { id: parseInt(wh) })) {
              return true;
            }
          }).id;

          var pr = q.pr;
          if (typeof pr == 'object') {
            pr = pr[0]; // pietiek ar vienu vērtību, jo nevar vienlaicīgi selektēt ply un other
          }
          var prType = _.find(this.filters.pr, function (o) {
            if (pr == o.id || _.find(o.children, { id: pr })) {
              return true;
            }
            return _.some(o.children, function (value) {
              return _.find(value.children, { id: parseInt(pr) });
            });
          }).id;

          if (prType == 'ply' && this.secret) {
            this.tableType = 3;
            return;
          }

          if (prType == 'ply') {
            if (whType == 'mt') {
              this.tableType = 1;
            } else {
              this.tableType = 2;
            }
          } else {
            this.tableType = 4;
          }

        },
        processTableData: function () {

          // Vairumtirdzniecības plātņu materiāliem stock vērtība ir paku skaits ir QtyAvailable / PcsInPack
          if (this.tableType == 2 || this.tableType == 3) {
            _.each(this.tableData, function (value) {
              value['stock'] = parseInt(value['stock'] / value['pcs_in_pack']);
            });
          }

          _.each(this.cartItems, (count, id) => {
            this.unitCount[id] = count;
            if (_.keyBy(this.tableData, 'id')[id]) { // ir uz ekrāna, jāupdeito vērtība
              this.$nextTick(() => {
                this.changeOrderCount(id, null, 'unit');
              });
            }
          });
        },
        changeUserFilter: function (command) {
          switch (command) {
            case 'create':
              this.$prompt($r.shop_filter_inputname, $r.shop_filter_inputname_title, {
                confirmButtonText: $r.shop_filter_save,
                cancelButtonText: $r.shop_filter_cancel,
                lockScroll: false,
                inputPattern: /^.{1,30}$/,
                inputErrorMessage: $r.shop_filter_sizemsg
              }).then(callback => {
                var newfilter = { filter_name: callback.value, filter: window.location.search.substring(1) };
                axios.post('/' + window.lang + '/user/createfilter', newfilter)
                  .then(() => {
                    var f = newfilter;
                    f.filter_type = 'custom';
                    this.userFilters.push(newfilter);
                    this.$toasted.global.success($r.shop_filter_saved);
                    // this.$notify({
                    //   message: $r.shop_filter_saved,
                    //   duration: 2500,
                    //   type: 'success',
                    // });
                  })
                  .catch();
              }).catch(err => {
                console.error(err);
              });
              break;
            default:
              this.currentFilterName = _.find(this.userFilters, {'filter': command}).filter_name;
              let q = removeUrlParam('pg', '?' + command);
              q = removeUrlParam('secret', q); // Admins var iekopēt urli ar secret no secret sadaļas- to vajag noņemt.
              
              if (this.$route.query.secret) {
                q += '&secret=' + this.$route.query.secret;
              }
              this.$router.replace(q);
              break;
          }
        },
        changedWarehouse: function (val) {
          var q = _.merge({}, this.$route.query);
          q.wh = val;
          q.pg = 1;
          this.$router.replace({
            query: q
          });
          this.someFiltersChanged();
        },
        changedProducts: function (val) {
          var q = _.merge({}, this.$route.query);
          q.pr = val;
          q.pg = 1;
          this.$router.replace({
            query: q
          });
          this.someFiltersChanged();
        },
        changedIndustries: function (val) {
          var q = _.merge({}, this.$route.query);
          q.in = val;
          q.pg = 1;
          this.$router.replace({
            query: q
          });
          this.someFiltersChanged();
        },
        changedApplications: function (val) {
          var q = _.merge({}, this.$route.query);
          q.ap = val;
          q.pg = 1;
          this.$router.replace({
            query: q
          });
          this.someFiltersChanged();
        },
        changedDiscount: function (val) {
          var q = _.merge({}, this.$route.query);
          delete q['discount'];
          if (val) {
            q.discount = 1;
          }
          q.pg = 1;
          this.$router.replace({
            query: q
          });
          this.someFiltersChanged();
        },
        changedRemains: function (val) {
          var q = _.merge({}, this.$route.query);
          delete q['rm'];
          if (val >= 0) {
            q.rm = val;
          }
          q.pg = 1;
          this.$router.replace({
            query: q
          });
          this.someFiltersChanged();
        },
        changedMultiselect: function (type, val) {
          var q = _.merge({}, this.$route.query);
          q[multiSelectQueryMap[type]] = val;
          q.pg = 1;
          this.$router.replace({
            query: q
          });
          this.someFiltersChanged();
        },
        changedThicknessFrom: function (val) {
          console.debug('izsaukts changedThicknessFrom');
          val = parseFloat(val);
          if (val < this.filters.thf) {
            val = this.filters.thf;
            this.dataThicknessFrom = val; 
          }
          this.dataThicknessRange = [val, this.dataThicknessRange[1]];

          var q = _.merge({}, this.$route.query);
          q.thf = val;
          q.pg = 1;
          this.$router.replace({
            query: q
          });
          this.someFiltersChanged();
        },
        changedThicknessTo: function (val) {
          console.debug('izsaukts changedThicknessTo');
          val = parseFloat(val);
          if (val > this.filters.tht) {
            val = this.filters.tht;
            this.dataThicknessTo = val;
          }
          this.dataThicknessRange = [this.dataThicknessRange[0], val];

          var q = _.merge({}, this.$route.query);
          q.tht = val;
          q.pg = 1;
          this.$router.replace({
            query: q
          });
          this.someFiltersChanged();
        },
        changedThicknessRange: function (val) {
          if (!isNaN(val[0])) {
            var q = _.merge({}, this.$route.query);
            q.thf = val[0];
            q.tht = val[1];
            q.pg = 1;
            this.$router.replace({
              query: q
            });
            this.someFiltersChanged();
          }
        },
        changedLengthFrom: function (val) {
          console.debug('izsaukts changedLengthFrom');
          val = parseFloat(val);
          if (val < this.filters.lnf) {
            val = this.filters.lnf;
            this.dataLengthFrom = val; 
          }
          this.dataLengthRange = [val, this.dataLengthRange[1]];
          
          var q = _.merge({}, this.$route.query);
          q.lnf = val;
          q.pg = 1;
          this.$router.replace({
            query: q
          });
          this.someFiltersChanged();
        },
        changedLengthTo: function (val) {
          console.debug('izsaukts changedLengthTo');
          val = parseFloat(val);
          if (val > this.filters.lnt) {
            val = this.filters.lnt;
            this.dataLengthTo = val; 
          }
          this.dataLengthRange = [this.dataLengthRange[0], val];

          var q = _.merge({}, this.$route.query);
          q.lnt = val;
          q.pg = 1;
          this.$router.replace({
            query: q
          });
          this.someFiltersChanged();
        },
        changedLengthRange: function (val) {
          if (!isNaN(val[0])) {
            var q = _.merge({}, this.$route.query);
            q.lnf = val[0];
            q.lnt = val[1];
            q.pg = 1;
            this.$router.replace({
              query: q
            });
            this.someFiltersChanged();
          }
        },
        changedWidthFrom: function (val) {
          console.debug('izsaukts changedWidthFrom');
          val = parseFloat(val);
          if (val < this.filters.whf) {
            val = this.filters.whf;
            this.dataWidthFrom = val;
          }
          this.dataWidthRange = [val, this.dataWidthRange[1]];

          var q = _.merge({}, this.$route.query);
          q.whf = val;
          q.pg = 1;
          this.$router.replace({
            query: q
          });
          this.someFiltersChanged();
        },
        changedWidthTo: function (val) {
          console.debug('izsaukts changedWidthTo');
          val = parseFloat(val);
          if (val > this.filters.wht) {
            val = this.filters.wht;
            this.dataWidthTo = val;
          }
          this.dataWidthRange = [val, this.dataWidthRange[1]];

          var q = _.merge({}, this.$route.query);
          q.wht = val;
          q.pg = 1;
          this.$router.replace({
            query: q
          });
          this.someFiltersChanged();
        },
        changedWidthRange: function (val) {
          if (!isNaN(val[0])) {
            var q = _.merge({}, this.$route.query);
            q.whf = val[0];
            q.wht = val[1];
            q.pg = 1;
            this.$router.replace({
              query: q
            });
            this.someFiltersChanged();
          }
        },
        changedFiberDirection: function (val) {
          var q = _.merge({}, this.$route.query);
          delete q['fd'];
          if (val) {
            q.fd = 1;
          }
          q.pg = 1;
          this.$router.replace({
            query: q
          });
          this.someFiltersChanged();
        },
        changedPageCount: function (pp) {
          var q = _.merge({}, this.$route.query);
          q.pp = pp;
          q.pg = 1;
          this.$router.replace({
            query: q
          });
        },
        changedPagination: function (newPage) {
          var q = _.merge({}, this.$route.query);
          q.pg = newPage;
          this.$router.replace({
            query: q
          });
          document.querySelector('.table-info').scrollIntoView({
            behavior: 'smooth'
          });
        },
        setDataFromQueryParams: function () {
          this.dataWarehouse = _.concat([], this.$route.query.wh);
          this.dataProducts = _.concat([], this.$route.query.pr);
          this.dataIndustries = _.concat([], this.$route.query.in);
          this.dataApplications = _.concat([], this.$route.query.ap);
          this.dataDiscount = this.$route.query.discount == '1';
          this.dataFiberDirection = this.$route.query.fd == '1';

          if (this.$route.query.pg) {
            this.tableCurrentPage = parseInt(this.$route.query.pg);
          } else {
            this.tableCurrentPage = 1;
          }

          if (this.$route.query.pp) {
            this.tablePageSelection = parseInt(this.$route.query.pp);
          } else {
            this.tablePageSelection = 25;
          }

          if (typeof this.$route.query.rm == 'undefined') {
            this.dataRemains = -1;
          } else {
            this.dataRemains = parseInt(this.$route.query.rm);
          }

          if (typeof this.$route.query.thf == 'undefined') {
            this.dataThicknessFrom = this.filters.thf;
          } else {
            this.dataThicknessFrom = parseFloat(this.$route.query.thf);
          }
          if (typeof this.$route.query.tht == 'undefined') {
            this.dataThicknessTo = this.filters.tht;
          } else {
            this.dataThicknessTo = parseFloat(this.$route.query.tht);
          }
          this.dataThicknessRange = [this.dataThicknessFrom, this.dataThicknessTo];
          this.thicknessDisabled = this.filters.thf == this.filters.tht;

          if (typeof this.$route.query.lnf == 'undefined') {
            this.dataLengthFrom = this.filters.lnf;
          } else {
            this.dataLengthFrom = parseFloat(this.$route.query.lnf);
          }
          if (typeof this.$route.query.lnt == 'undefined') {
            this.dataLengthTo = this.filters.lnt;
          } else {
            this.dataLengthTo = parseFloat(this.$route.query.lnt);
          }
          this.dataLengthRange = [this.dataLengthFrom, this.dataLengthTo];
          this.lengthDisabled = this.filters.lnf == this.filters.lnt;

          if (typeof this.$route.query.whf == 'undefined') {
            this.dataWidthFrom = this.filters.whf;
          } else {
            this.dataWidthFrom = parseFloat(this.$route.query.whf);
          }
          if (typeof this.$route.query.wht == 'undefined') {
            this.dataWidthTo = this.filters.wht;
          } else {
            this.dataWidthTo = parseFloat(this.$route.query.wht);
          }
          this.dataWidthRange = [this.dataWidthFrom, this.dataWidthTo];
          this.widthDisabled = this.filters.whf == this.filters.wht;
        },        
        updateData: function () {
          var $this = this;
          if (this.$route.query.wh.length == 0 || this.$route.query.pr.length == 0) {
            this.showDataTable = false;
            this.$toasted.global.warning($r.shop_msg_missing_req_fields);
            // this.$notify({
            //   message: $r.shop_msg_missing_req_fields,
            //   duration: 2500,
            //   type: 'warning',
            // });
            return;
          }
          if (this.showDataTable == false) {
            this.tableData = [];
            this.showDataTable = true;
          }

          this.tableLoading = true;
          axios.get('/' + window.lang + '/shop/data' + window.location.search)
            .then(response => {

              // Ja tiek atlasīti 0 produktu, biznesa prasība ir deslektēt visus filtrus, kas nav noliktavas un produkti,
              // vajadzīgs alerts un produktu / filtru atlase pa jaunu.
              /*if (response.data.products.length == 0) {
                const filterReduced = _.pickBy(this.$route.query, function (value, key) {
                  return _.includes(['wh', 'pr', 'secret'], key);
                });
                if (!_.isEqual(this.$route.query, filterReduced)) {
                  this.$toasted.global.info($r.shop_filter_combwarning);
                  // this.$notify({
                  //   message: $r.shop_filter_combwarning,
                  //   duration: 3500,
                  //   type: 'info',
                  // });
                  this.$router.replace({ 'query': filterReduced });
                  this.$refs.table.clearSort();
                }
              }*/

              this.contacts = response.data.contacts;
              this.filters = response.data.filters;
              this.cartItems = response.data.cart_items;
              this.tableData = response.data.products;
              this.totalRows = response.data.products_total;
              this.setDataFromQueryParams();
              this.setTableType();
              this.processTableData();

              // TODO: sucks, bet vai var labāk?
              this.$nextTick(() => {
                removeMultiSelectCallbacks();
                _.forEach(window.multiSelectElms, (e) => {
                  $('#' + e).selectMultiple('refresh');
                  // deselect_all gļučī, aizverot izvēlētos 
                  // vue multiselect dropdownus.
                  $('#' + e).selectMultiple('deselect', multiSelectOptions(e));
                  $('#' + e).selectMultiple('select', this.$route.query[multiSelectQueryMap[e]]);

                  // scrollbaru attiecīgā vietā katram multiselect elementam
                  if (window.multiSelectLastChecked[e]) {
                    const li = window.multiSelectObjs[e].$selectableUl.find('li').filter(function () {
                      return $(this)[0].firstChild.innerHTML == window.multiSelectLastChecked[e].value;
                    });
                    if (li.length > 0) {
                      window.multiSelectObjs[e].$selectableUl.scrollTop($(li)[0].offsetTop - window.multiSelectLastChecked[e].offset);
                    }
                  }

                });
                addMultiSelectCallbacks();
              });
            })
            .catch(err => {
              console.error(err);
            }).then(() => {
              $this.tableLoading = false;
              if ($this.focused_field != null)
                $this.focused_field.select();
              $('.btn-export-xls').prop('href', '/' + window.lang + '/shop/export/' + window.location.search + '&tpl=' + $this.tableType + '&sep=' + $this.getDecSep(window.lang));
                setTimeout(function (){
                  $this.xScroller_enabled = $this.showXScrollButtons();
                }, 500)
            });
        },
        getDecSep : function(locale_) {
          var n = 1.1;
          n = n.toLocaleString(locale_).substring(1, 2);
        return n;
        },
        sortTable: function (params) {
          var q = _.merge({}, this.$route.query);
          delete q['by'];
          delete q['or'];
          if (params.order && params.prop) {
            // Kaut kāds ElementUI bugs, kur spiežot ar peli ir strings, 
            // bet manuāli izsaucot sortēšanu .prop ir objekts ar vērtībām
            // if(typeof params.prop == 'object') {
            //     q.by = params.prop.prop;
            // } else {
            //     q.by = params.prop;
            // }
            q.by = params.prop;
            var order = 'asc';
            if (params.order == 'descending') {
              order = 'desc';
            }
            q.or = order;
          }
          this.$router.replace({
            query: q
          });
        },
        tableFormatter: function (row, column, cellValue, index) {
          try {
            switch (column.property) {
              case 'thickness':
                return Math.round(cellValue * 10) / 10;
                break;
              case 'price_one':
                return '€ ' + cellValue.toFixed(2);
                break;
              case 'price_m2':
                return '€ ' + cellValue.toFixed(2);
                break;
              // case 'smallimage':
              //     return '<img src="/' + window.lang + '/shop/image/' + row.id + '.jpg">';
              //     break;
              default:
                return cellValue;
                break;
            }
          } catch (error) {
            console.error(error);
            return cellValue;
          }
        },
        showImg: function (id) {
          var el = _.find(_.flatten($this.gallery), function (obj, i) {
            if (obj.imageElement.dataset.id == id) {
              obj.index = i;
              return true;
            }
          });
          baguetteBox.show(0, $this.gallery[el.index]);
        },
        deleteFilter: function (index) {
          this.cancelUserFilterClick = true;
          this.$confirm($r.shop_filter_del_q, '', {
            lockScroll: false,
          }).then(() => {
            var userIndex = index - _.filter(this.userFilters, { filter_type: 'predefined' }).length;
            axios.post('/' + window.lang + '/user/deletefilter', { index: userIndex })
              .then(() => {
                // delete this.userFilters[index];
                this.userFilters.splice(index, 1);
                this.$toasted.global.success($r.shop_filter_del_ok);
                // this.$notify({
                //   message: $r.shop_filter_del_ok,
                //   duration: 2500,
                //   type: 'success',
                // });
              })
              .catch(err => {
                console.error(err);
                this.$toasted.global.error($r.shop_filter_del_failed);
                // this.$notify({
                //   message: $r.shop_filter_del_failed,
                //   duration: 2500,
                //   type: 'error',
                // });
              });
          }).catch(() => { });
        },
        resetFilters: function () {
          this.$router.replace(window.location.pathname + '?' + $this.params.resetUrl);
          this.$refs.table.clearSort();
          this.$toasted.global.success($r.shop_filter_cleared);
          this.$nextTick(() => {
            this.$refs.clearFilterButton.$el.blur();
          });
          this.currentFilterName = null;
        },

        floor : function(var_) {
          var str = var_ + "";
          var dot = str.indexOf('.');
          if (dot == -1)
            return var_;
          else
            return parseFloat(str.slice(0, dot+3));

        },
        
        changeOrderCount: function (id, target, type) {

          // type ir 'unit' || 'm2'
          var prod = _.keyBy(this.tableData, 'id')[id];
          var target_formula = (this.tableType == 2 || this.tableType == 3 ? prod.m3_pcs_factor : prod.m2_pcs_factor);

          var pcsInPack = 1;
          if (this.tableType == 2 || this.tableType == 3) {
            pcsInPack = prod.pcs_in_pack;
          }

          // Tā kā update nāk arī pēc atvēršanas no sesijas datiem, 
          // tad šo funkciju jāvar izsaukt arī manuāli pēc datu atjaunošanas.
          if (target == null) {
            target = document.querySelector('[data-unit-input="' + id + '"] input');
          }
          if (target == null) { // uz mobilā savādāks selektors
            target = document.querySelector('[data-unit-input="' + id + '"]');
          }

          var requiredUnits = 0;
          if (type == 'unit') {
            requiredUnits = target.value;
            if (requiredUnits > prod.stock) {
              let msg = null;
              if (prod.stock == 0) {
                msg = $r.shop_prod_zero;
              } else {
                msg = $r.shop_onlyavailable_pt1 + ' ' + prod.stock + ' ' + $r.shop_onlyavailable_pt2;
              }
              this.$toasted.global.warning(msg);
              // this.$notify({
              //   type: 'warning',
              //   message: msg,
              //   duration: 2000,
              // });
              requiredUnits = prod.stock;
              target.value = prod.stock;
            }
            this.$set(this.unitCount, id, requiredUnits);
            var target_m2Count = parseFloat(new Big(new Big(requiredUnits).times(new Big(target_formula)).times(new Big(pcsInPack)).times(new Big(100))).div(new Big(100)));
            this.$set(this.m2Count, id, this.floor(target_m2Count).toFixed(2));
          } else {
            requiredUnits = Math.ceil(new Big(target.value).div(new Big(target_formula)).div(new Big(pcsInPack)));
            if (requiredUnits > prod.stock) {
              this.$toasted.global.warning($r.shop_availabla_pt1 + ' ' + prod.stock + ' ' + $r.shop_availabla_pt2);
              // this.$notify({
              //   type: 'warning',
              //   message: $r.shop_availabla_pt1 + ' ' + prod.stock + ' ' + $r.shop_availabla_pt2,
              //   duration: 2000,
              // });
              requiredUnits = prod.stock;
              target.value = parseFloat(new Big(new Big(requiredUnits).times(new Big(target_formula)).times(new Big(pcsInPack)).times(100)).div(100).toFixed(2));
              this.$set(this.m2Count, id, target.value);
            }
            this.$set(this.unitCount, id, requiredUnits);
          }
        },
      },
      mounted: function () {
          var $this = this;

          window.addEventListener('resize',  function (){
            $this.xScroller_enabled = $this.showXScrollButtons();
          });

          // close box if clicked anywhere on document
          document.addEventListener("click", function(event) {
            if (event.target.closest("#contact_card_shop") || event.target.closest(".js-wh-link")) return;
            if ($this.contacts_shown)
              $this.contacts_shown = false;
          });

        document.onscroll = function(e) {

            var scrolled = document.documentElement.scrollTop;
            if (isMobile() || $this.xScroller_enabled) {

              var tbl = document.querySelector('.w10col').offsetHeight;
              var tblheight = document.querySelector('#ptbl').offsetHeight;

              if (scrolled >= tbl && !$this.xScroller && scrolled < tbl + tblheight)
              {
                $this.xScroller = true;
              }
              else if (((scrolled < tbl) || (scrolled >= tbl + tblheight)) && $this.xScroller)
              {
                $this.xScroller = false;
              }
            }
          };

        document.onkeyup = function(evt) {
          evt = evt || window.event;
          if (evt.keyCode == 9)
            $this.focused_field = evt.target;
        };

        // Sliderim novācam tabindexus
        _.forEach(document.querySelectorAll('.el-slider'), (e) => {
          _.forEach(e.querySelectorAll('[tabindex="0"]'), (e) => {
            e.tabIndex = -1;
          });
        });

        if (!this.$route.query.wh || !this.$route.query.pr) {
          var q = { 'wh': (lang == 'en' ? 'vt' : 'mt'), 'pr': 'ply' };
          this.$router.replace({
            query: q
          });
        } else {
          this.updateData();
        }
      },
      watch: {
        '$route'(to, from) {
          this.setDataFromQueryParams();
          this.updateData();
        },
        tableData: function () {
          this.$nextTick(() => {
            $this.gallery = baguetteBox.run('.product-image');
          });
        },        
        dataThicknessRange: function (newValue) {
          this.dataThicknessFrom = newValue[0];
          this.dataThicknessTo = newValue[1];
        },        
        dataLengthRange: function (newValue) {
          this.dataLengthFrom = newValue[0];
          this.dataLengthTo = newValue[1];
        },        
        dataWidthRange: function (newValue) {
          this.dataWidthFrom = newValue[0];
          this.dataWidthTo = newValue[1];
        },
        lengthFrom: function (newValue) {
          this.lengthRange = [newValue, this.lengthRange[1]];
        },
        lengthTo: function (newValue) {
          this.lengthRange = [this.lengthRange[0], newValue];
        },
        lengthRange: function (newValue) {
          this.lengthFrom = newValue[0];
          this.lengthTo = newValue[1];
        },
        widthFrom: function (newValue) {
          this.widthRange = [newValue, this.widthRange[1]];
        },
        widthTo: function (newValue) {
          this.widthRange = [this.widthRange[0], newValue];
        },
        widthRange: function (newValue) {
          this.widthFrom = newValue[0];
          this.widthTo = newValue[1];
        },
      },
    });
  }
}

window.multiSelectOptions = (elm) => {
  var selected = [];
  _.forEach($('#' + elm + ' option:selected'), function (el) {
    selected.push(el.value);
  });
  return selected;
}

// https://krazedkrish.com/select-multiple
window.multiSelectElms = ['trademark', 'grade', 'color'];
window.multiSelectQueryMap = {
  'trademark': 'tm',
  'grade': 'gr',
  'color': 'co',
};
window.multiSelectObjs = {};
window.multiSelectLastChecked = {};
window.removeMultiSelectCallbacks = () => {
  _.forEach(multiSelectObjs, e => {
    e.options.afterSelect = null;
    e.options.afterDeselect = null;
  });
}

window.multiSelectCallbackFunc = (key, value) => {
  if (value.length == 1) {
    const scrollTop = window.multiSelectObjs[key].$selectableUl.scrollTop();
    const elmOffsetTop = $(window.multiSelectObjs[key].$selectableUl.find('li').filter(function () {
      return $(this)[0].firstChild.innerHTML == value[0];
    }))[0].offsetTop;
    window.multiSelectLastChecked[key] = {
      value: value[0],
      offset: elmOffsetTop - scrollTop,
    };
  }
  window.multiSelectObjs[key].lastActionValue = value;
  if (value.length > 0) {
    window.shop.vue.changedMultiselect(key, window.multiSelectOptions(key));
  }
}

// Jāpadod ar ?
window.removeUrlParam = function (key, sourceURL) {
  var rtn = sourceURL.split("?")[0],
    param,
    params_arr = [],
    queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
  if (queryString !== "") {
    params_arr = queryString.split("&");
    for (var i = params_arr.length - 1; i >= 0; i -= 1) {
      param = params_arr[i].split("=")[0];
      if (param === key) {
        params_arr.splice(i, 1);
      }
    }
    rtn = rtn + "?" + params_arr.join("&");
  }
  return rtn;
};

window.addMultiSelectCallbacks = () => {
  _.forEach(multiSelectObjs, (obj, key) => {
    obj.options.afterSelect = (value) => window.multiSelectCallbackFunc(key, value);
    obj.options.afterDeselect = (value) => window.multiSelectCallbackFunc(key, value);
  });
}

// document.addEventListener('DOMContentLoaded', () => {
  
// });

// Fix priekš Firefox lapu cachinga (back poga nepārģenerē dom un eventus)
// https://developer.mozilla.org/en-US/docs/Mozilla/Firefox/Releases/1.5/Using_Firefox_1.5_caching
window.addEventListener('unload', () => { });

window.Shop = Shop;
